'use strict';

const DOCS_ANCHOR_CLICK = 'DOCS_ANCHOR_CLICK';
const DOCS_SIDEBAR_CLICK = 'DOCS_SIDEBAR_CLICK';
const DOCS_SEARCH_INPUT = 'DOCS_SEARCH_INPUT';
const DOCS_SEARCH_SELECT = 'DOCS_SEARCH_SELECT';
const DOCS_COPY_EXAMPLE_CODE_CLICK = 'DOCS_COPY_EXAMPLE_CODE_CLICK';
const DOCS_LANGUAGE_SELECT = 'DOCS_LANGUAGE_SELECT';

export default {
  DOCS_ANCHOR_CLICK,
  DOCS_SIDEBAR_CLICK,
  DOCS_SEARCH_INPUT,
  DOCS_SEARCH_SELECT,
  DOCS_COPY_EXAMPLE_CODE_CLICK,
  DOCS_LANGUAGE_SELECT,
};
